
import React, { useContext, useEffect, useState } from 'react';
import { Nav, Tab } from "react-bootstrap";
import { useParams } from 'react-router';
import utilsPageSect from '../../../MyConns/_Utils/utilsPageSections';
import Breadcrumb from './Breadcrumb';
// import TabBuisDetails from './parts/TabBuisDetails';
// import TabImages from './parts/TabImages';
// import TabMaps from './parts/TabMaps';
// import TabNetwork from './parts/TabNetwork';
// import TabSales from './parts/TabSales';
// import TabPageDetails from './parts/TabPageDetails';
// import TabOpeningHours from './parts/TabOpeningHours';



import { useHistory } from "react-router-dom";
import { CurrentSingleContext } from '../../MyContexts/CurrentSingle_Context';
import { SectionsContext } from '../../MyContexts/Sections_Context';
import SelectImgComp from '../../MySections/ImagesSetter/SelectImgComp';
import EraseCheck from '../../MySections/PopUps/EraseCheck';
import SucessToast from '../../MySections/Toasts/SucessToast';

import SectionBuissMenu from './SectionBuissMenu';
import SectionContact from './SectionContact';
import SectionGallery from './SectionGallery';
import SectionHead2Btns from './SectionHead2Btns';
import SectionTextBlock from './SectionTextBlock';
// import BasicPopUp from '../../MySections/PopUps/BasicPopUp';
// import SucessToast from '../../MySections/Toasts/SucessToast';
// import TabPageDetails from '../compsForAllPages/TabPageDetails';
// import TabHPDetails from './parts/TabHPDetails';
// import TabMainRests from './parts/TabMainRests';
// import TabFavoRests from './parts/TabFavoRests';


const SingleSection = (props) => {
    const history = useHistory();
    const [Sections, setSections] = useContext(SectionsContext);
    const [currentSingle, setCurrentSingle] = useContext(CurrentSingleContext);

    const [currSingle, setCurrSingle] = useState();
    const [loading, setLoading] = useState(true);

    let params = useParams();
    const [thePopUp, setThePopUp] = useState("");
    const [mainTitle, setMainTitle] = useState("");
    const [mainImage, setMainImage] = useState("");
    const [mainImageMobile, setMainImageMobile] = useState("");
    const [mainContent, setMainContent] = useState("");
    const [mainImage2, setMainImage2] = useState("");
    const [mainContent2, setMainContent2] = useState("");
    const [pageName, setPageName] = useState("");
    const [inLinkToPage, setInLinkToPage] = useState("");
    const [SpecialScript, setSpecialScript] = useState("");


    const [linkChanged, setLinkChanged] = useState(false);



    useEffect(() => {
        if (props.newp) {
            createNewP();
        }
        else {
            getPageSection();

        }
    }, [])

    const createNewP = async () => {
        let theSingle = await utilsPageSect.createPageSection();
        if (theSingle != null) {
            props.upSimplsList(theSingle)
            history.push(theSingle.inLinkToPage)
        }
    }
    const tempUpdate = (upRest) => {
        // setHomeP(upRest);

    }

    const getPageSection = async () => {

        let theSingle = await utilsPageSect.getPageSectionById(props.pageId);

        if (theSingle.SpecialScript == null) {
            let tempScrpt = { ...theSingle, SpecialScript: "" }
            theSingle = tempScrpt;
        }

        setCurrentSingle(theSingle);


        setLoading(false)
    }


    const updateTheSingle = async () => {
        if (currentSingle._id != null) {
            console.log(currentSingle)
            let theSingle = await utilsPageSect.updateSingle(currentSingle);

            if (linkChanged) {
                document.location.href = theSingle.inLinkToPage;
            }
            else {
                SucessToast({ position: "toast-bottom-right", text: "עודכן בהצלחה!" });
            }
        }

    }

    const removePageSection = () => {
        if (currentSingle._id != null) {
            setThePopUp(<EraseCheck title={'האם בטוח למחוק את העמוד?'} sucecssFunc={() => removePageConfirmd(currentSingle._id)} />)
        }
    }

    const removePageConfirmd = async () => {
        let theSingle = await utilsPageSect.deletePageSection(currentSingle._id);
        let tempo = Sections.filter(itm => itm._id != currentSingle._id);
        setSections(tempo)

        history.push('/');

    }

    const updatePDetails = (key, val) => {
        currentSingle[key] = val;
    }

    // const updateGallImgs = (key, val) => {
    //         currentSingle[key] = val;

    //         setCurrentSingle(currentSingle)
    // }


    return (
        <div className="ms-content-wrapper SetBlock">
            <Breadcrumb />
            {/* Active Orders Graph */}
            <div className="row">
                <div className="col-md-12">
                    {loading ? "loading" :

                        <div className="ms-panel">
                            <div className="ms-panel-header">

                                <div className="form-row tabsInputs">
                                    <div className="col-md-12 mb-2 onLeft">
                                        <button type="button" className="onLeft btn btn-primary" onClick={() => removePageSection()}>מחק</button>
                                    </div>

                                    <div className={"col-md-12 mb-2"}>
                                        <div className={"col-md-5 mb-2 onRight"}>

                                            <div className={"col-md-12 mb-2"}>
                                                <label htmlFor={"validationCustom01"}>שם המקטע</label>
                                                <div className={"input-group"}>
                                                    <input type="text" className={"Big-form-control inputSPMain"}
                                                        placeholder={"שם המקטע"} value={(currentSingle.pageName) ? currentSingle.pageName : ""}
                                                        onChange={(e) => { currentSingle["pageName"] = e.target.value; setPageName(e.target.value); setLinkChanged(true) }} />
                                                </div>
                                            </div>
                                            <div className={"col-md-12 mb-2"}>
                                                <label htmlFor={"validationCustom01"}>קישור חכם</label>
                                                <div className={"input-group"}>
                                                    <input type="text" className={"Big-form-control inputSPMainL"}
                                                        placeholder={"קישור חכם"} value={(currentSingle.inLinkToPage) ? currentSingle.inLinkToPage : ""}
                                                        onChange={(e) => { currentSingle["inLinkToPage"] = e.target.value; setInLinkToPage(e.target.value); setLinkChanged(true) }} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"col-md-3 mb-2 onLeft"}>
                                            <label htmlFor={"validationCustom1_6"}>תמונת רקע מובייל</label>
                                            <span className={"explanation mediumst fullROw"}></span>
                                            <SelectImgComp firstImgToDisp={currentSingle.mainImageMobile}
                                                theFunction={(fUrl) => { currentSingle["mainImageMobile"] = fUrl; setMainImageMobile(fUrl) }} />

                                        </div>
                                        <div className={"col-md-3 mb-2 onLeft"}>
                                            <label htmlFor={"validationCustom1_6"}>תמונת רקע</label>
                                            <span className={"explanation mediumst fullROw"}></span>
                                            <SelectImgComp firstImgToDisp={currentSingle.mainImage}
                                                theFunction={(fUrl) => { currentSingle["mainImage"] = fUrl; setMainImage(fUrl) }} />

                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div className="col-md-12">

                                <div className="ms-panel-body clearfix">

                                    <Tab.Container defaultActiveKey={currentSingle.sectiontype?.toString() || "1"}
                                        onSelect={(key) => { currentSingle["sectiontype"] = key }} >
                                        <Nav variant="tabs" className="nav nav-tabs d-flex nav-justified mb-2">
                                            <Nav.Item>
                                                <Nav.Link eventKey="1">קוביית טקסט</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="2">כותרת + 2 כפתורים</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="3">גלרייה</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="4">צור קשר</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="5">תפריט</Nav.Link>
                                            </Nav.Item>
                                            {/* <Nav.Item>
                                                <Nav.Link eventKey="10">style2</Nav.Link>
                                            </Nav.Item> */}
                                        </Nav>
                                        <Tab.Content>
                                            {/*תוכן*/}
                                            <Tab.Pane eventKey="1">
                                                <SectionTextBlock thePage={currentSingle}
                                                    theSectionUpdate={(key, val) => updatePDetails(key, val)} />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="2">
                                                <SectionHead2Btns thePage={currentSingle}
                                                    theSectionUpdate={(key, val) => updatePDetails(key, val)} />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="3">
                                                <SectionGallery thePage={currentSingle}
                                                    theSectionUpdate={(key, val) => updatePDetails(key, val)} />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="4">
                                                <SectionContact thePage={currentSingle}
                                                    theSectionUpdate={(key, val) => updatePDetails(key, val)} />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="5">
                                                <SectionBuissMenu thePage={currentSingle}
                                                    theSectionUpdate={(key, val) => updatePDetails(key, val)} />
                                            </Tab.Pane>
                                            {/* פרטי העמוד */}
                                            {/* <Tab.Pane eventKey="10">
                                                <div className="form-row tabsInputs ">
                                                    <TabPageDetails pgToSet="pgPageDetails"
                                                        thePage={currentSingle} thePageUpdate={(key, val) => updatePDetails(key, val)} />
                                                </div>
                                            </Tab.Pane> */}

                                        </Tab.Content>
                                    </Tab.Container>
                                </div>



                            </div>
                        </div>
                    }
                </div>
            </div>
            <div className="ms-panel-header approveLine">
                <button type="button" className="onLeft btn btn-primary" onClick={() => updateTheSingle()}>שמור</button>
            </div>
            {thePopUp}
        </div >
    );
}



export default SingleSection;